
import React from 'react';
import './media.css';

const Media = () => {
    return (
        <div className='page-basics'>
            <h2>Media</h2>
            <h3>Television</h3>
            <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
                <iframe
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%'
                    }}
                    src="https://www.youtube.com/embed/USQ4TWzcCc0"
                    title="Ann Olivier, Prof. Chris Scott - 25 Maart 2019"

                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture web-share" allowFullScreen
                    referrerpolicy="strict-origin-when-cross-origin"
                >

                </iframe>
            </div>
            <br />

            <h3>Radio</h3>
            <div>
                <figure className="block-audio">
                    <audio src="CCFM107.5-9-to-12-Vikki-With-Ann.mp3" controls="controls" className='block-audio'>
                    </audio>
                    <figcaption>CCFM 94.7 Interview 2019</figcaption>
                </figure>

                <figure class="wp-block-audio">
                    <audio src="Arthritis-Foundation-Interview-Bush-Radio-The-Morning-Cruise-Kosi-Veto-1-2.mp3" controls="controls" className='block-audio'>
                    </audio>
                    <figcaption>Bush Radio Interview 2019
                    </figcaption>
                </figure>
                <figure class="wp-block-audio">
                    <audio src="Radio-786-Discussing-Juvenile-Arthritis-with-the-Arhritis-Foundation-13-03-19.mp3" controls="controls" className='block-audio'>
                    </audio>
                    <figcaption>Radio 786 Interview 2019</figcaption>
                </figure>
            </div>
            <br />
            <h3>Print Media/Other</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px' }}>
                <div>
                    <img src='Ann-1.jpg' alt='Arthritis Insight Magazine' style={{ objectFit: 'cover', height: '100%', aspectRatio: '3/4' }} />
                    <div className='img-footer'>
                        Arthritis Insight Magazine
                    </div>
                </div>

                <div>
                    <img src='WordDay.jpg' alt='WORD Day' style={{ objectFit: 'cover', height: '100%', aspectRatio: '3/4' }} />
                    <div className='img-footer'>
                        WORD Day
                    </div>
                </div>

                <div>
                    <img src='SARAA.png' alt='SARAA Conference' style={{ objectFit: 'cover', height: '100%', aspectRatio: '3/4' }} />
                    <div className='img-footer'>
                        SARAA Conference
                    </div>
                </div>

                <div>
                    <img src='Ann-2.jpg' alt='Article in Fair Lady, Men`s Health, Bicycling & Runnes Magazines' style={{ objectFit: 'cover', height: '100%', aspectRatio: '3/4' }} />
                    <div className='img-footer'>
                        Fair Lady & Men's Health
                    </div>
                </div>

                <div>
                    <img src='Kyknet1.jpeg' alt='Kyknet Studios' style={{ objectFit: 'cover', height: '100%', aspectRatio: '3/4' }} />
                    <div className='img-footer'>
                        Kyknet Studios
                    </div>
                </div>

                <div>
                    <img src='BushRadio.jpeg' alt='Bush Radio Interview' style={{ objectFit: 'cover', height: '100%', aspectRatio: '3/4' }} />
                    <div className='img-footer'>
                        Bush Radio Interview
                    </div>
                </div>

                <div>
                    <img src='Lupus.jpeg' alt='Lupus Fun Run' style={{ objectFit: 'cover', height: '100%', aspectRatio: '3/4' }} />
                    <div className='img-footer'>
                        Lupus Fun Run
                    </div>
                </div>

                <div>
                    <img src='Kyknet2.jpeg' alt='Kyknet Studios' style={{ objectFit: 'cover', height: '100%', aspectRatio: '3/4' }} />
                    <div className='img-footer'>
                        Kyknet Studios
                    </div>
                </div>
                <div >
                    <img src='Kyknet3.jpeg' alt='Kyknet Studios' style={{ objectFit: 'cover', height: '100%', aspectRatio: '3/4' }} />
                    <div className='img-footer'>
                        Kyknet Studios
                    </div>
                </div>
            </div>


            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />

        </div>
    );
};

export default Media;